module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//harvest-right.png?v=6ac39206";